module.exports = __webpack_public_path__ + "static/media/super3.28da5fd1.webp";